import { AfterViewInit, ChangeDetectionStrategy, Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

import { ComponentSize } from '@core/interfaces';

@Component({
  selector: 'z-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoResultsComponent implements OnInit, OnDestroy, AfterViewInit {
  destroy$ = new Subject<void>();

  @Input() gridId: string;
  @Input() type: string = 'no-results';
  @Input() size: ComponentSize = 'normal';
  @Input() sizeOffset: number = 4;

  @Input() iconLayer1: string = 'fa-thin fa-magnifying-glass fa-stack-1x';
  @Input() iconLayer2: string = 'fa fa-exclamation fa-flash fa-stack-2x';

  @Input() title: string;
  @Input() description: string;

  @Input() showDescription: boolean = true;
  @Input() showIconLayer1: boolean = true;
  @Input() showIconLayer2: boolean = true;

  @Input() animate: boolean = true;

  @Input() parentSelector: string;

  width$ = new BehaviorSubject<string>(null);

  target: any;
  observer: ResizeObserver;

  constructor(private zone: NgZone) {}

  ngOnInit() {
    if (!this.parentSelector) {
      this.parentSelector = `#${this.gridId} .p-datatable-grid`;
    }

    this.observer = new ResizeObserver((entries) => {
      this.zone.run(() => {
        const width = Math.floor(entries[0].contentRect.width - this.sizeOffset);
        this.width$.next(`${width}px`);
      });
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();

    try {
      if (this.observer && this.target) {
        this.observer.unobserve(this.target);
      }
    } catch {}
  }

  ngAfterViewInit() {
    try {
      setTimeout(() => {
        this.target = document.querySelector(this.parentSelector);

        if (this.target) {
          this.observer.observe(this.target);
        }
      }, 0);
    } catch {}
  }

  update() {
    this.target = document.querySelector(this.parentSelector);

    if (this.target) {
      const width = Math.floor(this.target.offsetWidth - this.sizeOffset);
      this.width$.next(`${width}px`);
    }
  }
}
